import {
  getLeadMetaAPI,
  LeadMetaParsedData,
} from '@services/new/common/getLeadMeta';
import {QueryClient, useQuery} from '@tanstack/react-query';

export const getLeadMetaQueryKey = (lang?: string) => ['leadMeta', lang];

export const getLeadMetaQueryFn = (lang?: string) => getLeadMetaAPI(lang).send;

export const prefetchLeadMeta = async (queryClient: QueryClient, lang?: string) => {
  const response = await getLeadMetaQueryFn(lang)();
  await queryClient.prefetchQuery({
    queryKey: getLeadMetaQueryKey(lang),
    queryFn: () => response,
  });
  return response;
};
const useLeadMetaQuery = (lang?: string) => {
  return useQuery<LeadMetaParsedData>({
    queryKey: getLeadMetaQueryKey(lang),
    queryFn: getLeadMetaQueryFn(lang),
    staleTime: Infinity,
  });
};

export default useLeadMetaQuery;
